import React, { Component } from "react";
import {
  CourseResource,
  CoursesResource,
} from "../../../stores/CoursesStore/Types";
import { getRequest } from "../../../utils/httpRequest";
import { AxiosResponse } from "axios";
import NewCourse from "../../Home/components/Courses/NewCourse";

interface Props {
  courseSlug: string;
  sectionTitle?: string;
  userIsInUk: boolean;
  // Restricts the rail to courses somebody can start today. Off by default so
  // the marketing rails keep teasing what is coming; the certificate page,
  // which is answering "what next?", turns it on.
  availableOnly?: boolean;
}

interface State {
  featuredCourses: CoursesResource;
  loaded: boolean;
}

class FeaturedCourses extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      featuredCourses: [],
      loaded: false,
    };
  }

  componentDidMount() {
    const { courseSlug, availableOnly } = this.props;

    if (!courseSlug) return null;

    const query = availableOnly ? "?available=true" : "";

    return getRequest(`/api/courses/${courseSlug}/suggested.json${query}`).then(
      (response: AxiosResponse) => {
        this.setState({ featuredCourses: response.data, loaded: true });
      },
    );
  }

  courseImageUrl = (course: CourseResource) => {
    const { userIsInUk } = this.props;

    return userIsInUk && course.preview_masthead_alt_image_url
      ? course.preview_masthead_alt_image_url
      : course.preview_masthead_image_url || course.masthead_image_url;
  };

  render() {
    const { userIsInUk } = this.props;
    const { featuredCourses, loaded } = this.state;

    if (loaded && featuredCourses.length === 0) return null;

    return (
      <div className="ui segment courses featured-courses">
        <section className="related" aria-labelledby="related-title">
          {!loaded && (
            <div className="ui active inverted dimmer">
              <div className="ui text loader">Loading</div>
            </div>
          )}

          <div className="container">
            <div className="head">
              <h2 className="section-title" id="related-title">
                {this.props.sectionTitle ||
                  "If you liked this, you might also fancy"}
              </h2>
            </div>

            <div className="related-grid">
              {featuredCourses.map((course) => (
                <NewCourse
                  courseResource={course}
                  key={course.id}
                  userIsInUk={userIsInUk}
                />
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default FeaturedCourses;
